import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';

import { Component as NotFavoriteIcon } from 'icons/icon-ui--heart-empty.svg';
import SkeletonLine from 'components/shared/skeletons/SkeletonLine';

function TitleSkeleton(): ReactElement {
  return (
    <div className="c-meal-management-recipes-container__title">
      <h2 className="c-heading c-heading--brand-4">
        <SkeletonLine width={300} height={30} />
      </h2>
      <div className="u-text d-none d-sm-block">
        <SkeletonLine width={500} height={18} />
      </div>
    </div>
  );
}

function RecipeSkeleton(): ReactElement {
  return (
    <div className="col-12 col-sm-6 col-lg-4 c-recipe">
      <div className="c-recipe__container">
        <div className="c-recipe__content--top">
          <div className="c-recipe__image-wrapper">
            <div className="c-recipe__added c-recipe__added--skeleton">
              <SkeletonLine width={80} height={18} className="mt-1 mb-2" />
            </div>
            <div className="c-recipe__content--top">
              <div className="c-skeleton-square" />
            </div>
          </div>
        </div>
        <div className="c-recipe__content--center">
          <div className="c-recipe__title">
            <h3>
              <SkeletonLine width={240} height={22} className="d-none d-md-block" />
              <SkeletonLine width={200} height={22} className="d-block d-md-none" />
              <SkeletonLine width={280} height={18} className="d-none d-md-block" />
              <SkeletonLine width={240} height={18} className="d-block d-md-none" />
            </h3>
          </div>
        </div>
        <div className="c-recipe__content--bottom">
          <SkeletonLine width={140} height={13} />
        </div>
        <div className="c-add-to-cart">
          <div className="c-add-to-cart__disabled c-skeleton-square" />
        </div>
      </div>

      <button
        disabled
        type="button"
        className="c-button c-favorite c-favorite--skeleton"
      >
        <span>
          <NotFavoriteIcon width="26" />
          Removed from Favorites
        </span>
      </button>
    </div>
  );
}

function Skeleton(): ReactElement {
  const seed = useUIDSeed();

  return (
    <main className="c-meal-management--skeleton">
      <div className="l-container">
        <div className="c-meal-management-recipes-container">
          <TitleSkeleton />
          <div className="c-form-group c-recipe-gallery">
            <div className="row">
              {[...Array(6)].map((el, i) => (
                <RecipeSkeleton key={seed(i)} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Skeleton;
